import { Button, Dialog, Typography } from '@mui/material';

import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import styles from '../styles/Page404.module.css';

export const Page404 = () => {
  return (
    <Dialog open={true} fullScreen>
      <Grid
        container
        spacing={8}
        justifyContent="center"
        alignItems="center"
        className={styles.gridContainer}
      >
        <Grid xs={12} className={styles.gridItem}>
          <Typography variant="h1">
            <strong>404</strong>
          </Typography>
        </Grid>
        <Grid xs={12} className={styles.gridItem}>
          <Typography variant="h4">Page not found</Typography>
        </Grid>
        <Grid xs={12} className={styles.gridItem}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              window.location.href = '/';
            }}
          >
            Take me home
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};
